export enum AttrtypeEnum {
    manufacturer = 0,
    item = 1,
    vendorItem = 2
}
